import { Injectable } from "@angular/core";
import { UserRole } from "@assoanalytics/app/core/models/user/user-role";

export interface BadgeItem {
  type: string;
  value: string;
}
export interface Saperator {
  name: string;
  type?: string;
}
export interface SubChildren {
  state: string;
  name: string;
  type?: string;
}
export interface ChildrenItems {
  state: string;
  name: string;
  type?: string;
  child?: SubChildren[];
}

export interface Menu {
  state: string;
  name: string;
  type: string;
  icon: string;
  badge?: BadgeItem[];
  saperator?: Saperator[];
  children?: ChildrenItems[];
  roles: UserRole[];
}

const MENUITEMS: Menu[] = [
  {
    state: "dashboard",
    name: "menu.dashboard",
    type: "link",
    icon: "dashboard",
    roles: [UserRole.Net, UserRole.Plant],
  },
  {
    state: "/transactions",
    name: "/transactions",
    type: "link",
    icon: "receipt_long",
    roles: [UserRole.Net, UserRole.Plant],
  },
  {
    state: "closures",
    name: "menu.closures",
    type: "link",
    icon: "today",
    roles: [UserRole.Net, UserRole.Plant],
  },
  {
    state: "business-intelligence",
    name: "menu.business-intelligence",
    type: "link",
    icon: "analytics",
    roles: [UserRole.Net],
    badge: [
      {
        type: "warning",
        value: "beta",
      },
    ],
  },
];

@Injectable()
export class MenuItems {
  getMenuitem(): Menu[] {
    return MENUITEMS;
  }
}
